import React from 'react';
import I18n from 'lib/i18n/i18n';
import ListingGoogleMap from './listingGoogleMap'
import UserActions from "lib/userActions";
import {
    WORTHY_ADDRESS,
    SHIPMENT_METHOD,
    isMobile,
    VALIDATION_NEEDED,
    ESTIMATION_READY,
    SHIPPING,
    ADDRESS_WAITING,
    NEW,
    IN_TRANSIT,
    DELIVERED,
    SHIPMENT_DOM_ID,
    LD_SK_EXP_VERSION,
    INSURANCE_CERTIFICATE_LINK,

    STEP_ADDRESS,
    STEP_PHONE,
    STEP_PICKUP,
    OPENED_SCHEDULE_MODAL
} from "../../helpers/ApplicationHelper";

import {
    LargePrimaryButton,
    LargeSecondaryButton,
    XLPrimaryButton
} from "@worthy-npm/clarity";

import ScheduleShipmentModalPopup from "../popups/scheduleShipmentModalPopup";
import {connect} from "react-redux";
import {browserHistory} from "react-router";

import Listing from './listing';

const shippingInstructions = process.env.SHIPPING_INSTRUCTIONS;

class ShipmentInformation extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showTitle: props.showTitle ? props.showTitle : true };
        this.isMobile = isMobile();
        this.stopAnimation = undefined;
    }

    renderTitle () {
        const { item } = this.props;
        let text = I18n.getString(`shipmentInformation::titleGeneral`);

        if (item && item.shipment) {
            if (item.shipment.shipment_method === SHIPMENT_METHOD['Pickup']) {
                text = I18n.getString(`shipmentInformation::titlePickup`)
            }
        }

        return (
            <h2 className='listing-title h2'>{text}</h2>
        )
    }

    removeInvalidKeys(pairs) {
        const { item } = this.props;
        const shipment = item.shipment;
        let invalidKeys = [];

        if (shipment.shipment_method === undefined) return pairs;

        if (shipment.shipment_method === SHIPMENT_METHOD['In-Person Drop Off']) {
            invalidKeys.push('Ship from')
            invalidKeys.push('Ship to')
            invalidKeys.push('Insurance')
            invalidKeys.push('Packing instructions')
        }

        if (shipment.shipment_method !== SHIPMENT_METHOD['In-Person Drop Off']) {
            invalidKeys.push('Address')
            invalidKeys.push('Time')
        }

        if (shipment.shipment_method !== SHIPMENT_METHOD['Drop Off']) {
            invalidKeys.push('Drop off locations')
        }

        if (shipment.shipment_method !== SHIPMENT_METHOD['Pickup']) {
            invalidKeys.push('When')
        }

        if (Listing.getVersion(this.props) === LD_SK_EXP_VERSION) {
            if (item.shipping_kit && item.shipping_kit.status === DELIVERED) {
                invalidKeys.push('Instructions');
            } else {
                invalidKeys.push('Shipping kit');
            }
        } else {
            invalidKeys.push('Shipping kit');
        }
        if (!item.shipping_kit) {
            invalidKeys.push('Shipping kit');
        }

        invalidKeys.forEach((key) => {
            delete pairs[key]
        });
        return pairs;
    }

    renderPairs(pairs){
        return (
            <div className='pairs-container'>
                {
                    Object.keys(pairs).map((key, idx) => {
                       return <div key={idx} className={`pair-item pair-item_number-${idx}`}>
                            <span className='pair-name'>{key}</span>
                            <span className='pair-value'>{pairs[key]}</span>
                        </div>
                    })
                }
            </div>
        )

    }

    renderInsurance(){
        return (
            <React.Fragment>
                <span> {I18n.getString('shipmentInformation::insurance::valueText')}</span>
                <a className='instructions-link'
                    href={INSURANCE_CERTIFICATE_LINK}
                    target={this.isMobile ? '_self' : '_blank'}> {I18n.getString('shipmentInformation::insurance::certificateLink')}
                </a>
            </React.Fragment>
        )
    }
    openSchedulePickupForm = (step, stopAnimation) => {
        const itemId = this.props.item.id;
        const { version, logger, isSKExperiment } = this.props;
        if (this.isMobile) {
            window.localStorage.setItem(OPENED_SCHEDULE_MODAL+`_${itemId}`, true)
            this.props.openSchedulePickupFormForMobile(itemId, step);
        } else {
            ScheduleShipmentModalPopup.initPopup({
                logger,
                step: step,
                version: version,
                itemId: itemId,
                isSKExperiment
            });
        }
        if (stopAnimation) {
            stopAnimation()
        }
    }

    getPairs() {
        let {
            item,
            logger,
            version,
            editable
        } = this.props;

        if (typeof editable === 'undefined') {
            editable = true;
        }

        const shipment = item.shipment;
        const locations = shipment.locations;
        let pairs = {
            'Shipping kit': 'Delivered',
            'Contents': item.desc,
            'Address': `${shipment.office_drop_off_appointment && shipment.office_drop_off_appointment.office_address}`,
            'Time':   <div className='pickup-time'>{shipment.office_drop_off_appointment ? (shipment.office_drop_off_appointment.state === "canceled" ? "Canceled" : shipment.office_drop_off_appointment.time) : '' }</div>,
            'Ship from': <div className='ship-from'>
                <span>{shipment.formatted_address}</span>
                {
                    editable ?
                        <i className={`icon-pencil margin-left`} title='Edit Address' onClick={ () => {
                            logger('«Edit address» from Shipment Information clicked', { itemId: item.id, version: version });
                            this.openSchedulePickupForm(STEP_ADDRESS)
                        }}/> : null
                }
            </div>,
            'Ship to': WORTHY_ADDRESS,
            'Drop off locations': <ListingGoogleMap locations={locations} />,
            'When': <div className='pickup-time'>{shipment.active_pickup ? shipment.active_pickup_time : ''}</div>,
            'Insurance': this.renderInsurance(),
            'Packing instructions': <a className='instructions-link'
                               href={shippingInstructions}
                               target={this.isMobile ? '_self' : '_blank'}>Open</a>
        };
        //filter out the non related keys based on shipment method
        let validPairs = this.removeInvalidKeys({ ...pairs });

        return validPairs;
    }

    openTrackingInfo = (stopAnimation) => {
        let { item } = this.props;
        stopAnimation();
        window.open(item.shipping_kit.tracking_url);
    }

    render() {
        let { id, item, editable, showTitle } = this.props;

        const shipment = item && item.shipment;
        // FIXME shipment.active_pickup doesn't update automatically even after pickup is scheduled
        if (typeof editable === 'undefined') {
            editable = true;
        }
        if (shipment) {
            // TODO: WORTHY:11005 Request SK Exp
            if (Listing.getVersion(this.props) === LD_SK_EXP_VERSION) {
                if (item.shipping_kit && item.shipping_kit.status && item.shipping_kit.status !== DELIVERED) {
                    return (
                        <div className='shipment-information shipment-information-shipment-kit' id={SHIPMENT_DOM_ID}>
                            <h3 className='listing-title h3'>{ I18n.getString('shippingKit::shippingKitShipmentDetails::title') }</h3>
                            <div className='shipping-kit-banner'>
                                <p className="shipping-kit-description">{ I18n.getString('shippingKit::shippingKitShipmentDetails::description') }</p>
                                <div className='pairs-container'>
                                    <div className='pair-item pair-item_number-1'>
                                        <span className='pair-name'>{ I18n.getString('shippingKit::shippingKitShipmentDetails::pairName') }</span>
                                        <span className='pair-value'
                                            dangerouslySetInnerHTML={{ __html: I18n.getString('shippingKit::shippingKitShipmentDetails::pairValue')
                                                .replace('{status}', `${ item.shipping_kit.status === NEW ? 'Preparing to ship ' : 'In transit ' }`)
                                                .replace('{address}', shipment.formatted_address)
                                            }}/>
                                    </div>
                                </div>
                            </div>
                            {
                                item.shipping_kit.status === IN_TRANSIT && item.shipping_kit.tracking_url ?
                                    <div className='shipping-kit-tracking-cta-wrap' data-automation='track-your-kit-btn'>
                                        <XLPrimaryButton
                                            click={ (stopAnimation) => this.openTrackingInfo(stopAnimation) }
                                            text={ I18n.getString('shippingKit::ctaTrackSK') }/>
                                    </div> : null
                            }
                        </div>
                    );
                }
            }
            let pairs = this.getPairs();

            return (
                <div className='shipment-information' id={id}>
                    { showTitle ? this.renderTitle() : null }
                    {this.renderPairs(pairs)}
                </div>
            )
        } else {
            return <div className='shipment-information' id={id}></div>
        }
    }
}

const mapStateToProps = ({ Item, Experiments, ADO, Personalized }) => {
    return {
        item: Item,
        experiments: Experiments,
        ADO: ADO,
        P13N: Personalized
    }
};

export default connect(mapStateToProps)(ShipmentInformation);
